import angular from 'angular'

import { noop, wrap } from 'lodash-es'
import { delFromArray } from '../utils/arrayh'

import idlize from '../utils/idlize'
import getSize from '../utils/get-size'
import StrictObj from '../utils/strict-obj'
import debugFields from '../utils/debug-fields'
import extractRawElm from '../utils/extract-raw-elm'

import ResizeDetector from '../utils/resize-detector'

angular
  .module('ggs.element-query')
  .factory('ElementQueryInternal', ElementQueryInternalProvider)
  .factory('ElementQuery', ElementQueryProvider)

/* available in query:
    - width
    - height
    - innerWidth
    - innerHeight
    - outerWidth
    - outerHeight
*/

function ElementQueryInternalProvider(debugObj) {
  const regs = []

  return debugObj('ElementQueryInternal', StrictObj(debugFields(register, {
    _regs: regs,
    _recalc: recalc,
    _release: release
  })))

  function register($elm, query, callback) {
    const elm = extractRawElm($elm)
    const reg = StrictObj({ elm, query, callback })

    reg.local = undefined
    reg.result = undefined
    reg.irecalc = idlize(wrap(reg, recalc))
    reg.destroy = wrap(reg, release)
    reg.detector = ResizeDetector(elm)
    reg.detector.on(reg.irecalc)
    reg.irecalc()

    regs.push(reg)
    return reg
  }

  function release(reg) {
    reg.detector.off(reg.irecalc)
    reg.query = noop
    reg.irecalc = noop
    reg.destroy = noop
    reg.callback = noop
    delFromArray(regs, reg)
  }

  function recalc(reg) {
    const local = getSize(reg.elm)
    const result = reg.query(local)
    reg.local = local
    if (reg.result === result) return
    reg.result = result
    reg.callback(result)
  }
}

function ElementQueryProvider(
  debugObj,
  $rootScope,
  ApplyAsync,
  ElementQueryInternal) {

  return debugObj('ElementQuery', ElementQuery)

  function ElementQuery($elm, query, callback) {
    return ElementQueryInternal($elm, query, ApplyAsync($rootScope, callback))
  }
}
